import styled from 'styled-components';
import { Table, Form } from 'react-bootstrap';

export const TableWrapper = styled(Table)`
    margin-bottom: 0px;
    
    & > thead > tr > th {
        border-bottom: 2px solid black;
        background-color: #b0c4de;
        text-align: center;
        white-space:nowrap;
        padding:3px 2px;
    }

    & > tbody > tr > td {
        padding: 1px;
        text-align: center;
        vertical-align: middle;
        max-width: 55px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
`;

export const FormWrapper = styled(Form)`
    .form-group {
        margin-bottom: 1px;
    }
`;

export const ConfigWrapper = styled.table`
    margin-bottom: 10px;

    & > tbody > tr > td {
        padding: 3px;
    }

    & > tbody > tr:first-child > td {
        padding-bottom: 5px;
    }

    .input-group-addon {
        line-height: 1;
    }
`;

export const MatchSetupWrapper = styled.div`
    .panel-heading {
        padding: 5px 10px;
    }

    .panel-body {
        padding: 7.5px;
    }
`;